import styled from "styled-components";

export const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
